






















































































































































import Vue from 'vue';
import { Type, ForExpression, Expression, NoExpression, BooleanType, NumberType, ChainExpression } from 'expangine-runtime';
import ExpressionBase from '../ExpressionBase';


export default ExpressionBase<ForExpression>().extend({
  name: 'ForEditor',
  data: () => ({
    configuring: false,
  }),
  computed: {
    variableType(): Type {
      return new NumberType({ whole: true, min: 0 });
    },
    bodyContext(): Type {
      return this.registry.defs.getContext(this.context, this.value.getScope());
    },
    configureLabel(): string {
      return this.configuring
        ? 'Hide For Options'
        : 'Show For Options';
    },
    textStart(): string {
      return `For ${this.value.variable} =`;
    },
    textEnd(): string {
      return `While ${this.value.variable} <`;
    },
    hasChain(): boolean {
      return this.value.body instanceof ChainExpression;
    },
  },
  methods: {
    updateStart(start?: Expression) {
      this.value.start = start || NoExpression.instance;
      this.update();
    },
    updateEnd(end?: Expression) {
      this.value.end = end || NoExpression.instance;
      this.update();
    },
    updateBody(body?: Expression) {
      this.value.body = body || NoExpression.instance;
      this.update();
    },
    toggleConfigure() {
      this.configuring = !this.configuring;
    },
  },
});
